<label class="formfield__label">
  <strong>{{ label }}</strong>
</label>
<input
  id="company_search"
  #input
  [ngClass]="className"
  type="text"
  [autocomplete]="autocomplete ? '' : 'disabled'"
  [placeholder]="placeholder"
  (focus)="focus.emit($event)"
  (focusout)="focusout.emit($event)"
  (blur)="onBlur()"
  [formControl]="searchControl"
  [privacySensitive]="privacySensitive"
/>
<ns-type-ahead-suggestions
  
  *ngIf="showSuggestions"
  (selected)="setSearchControlValue($event)"
  [suggestIcon]="suggestIcon"
  [suggestions]="suggestions"
>
</ns-type-ahead-suggestions>
